// src/hooks/useHandleApiResponse.js

import { useSnackbar } from 'notistack';

const useHandleApiResponse = () => {
  const { enqueueSnackbar } = useSnackbar();

  const handleApiResponse = (res, { onSuccess, onFailed } = {}) => {
    if (res?.payload?.status === 'failed' || res?.payload?.status === 'error') {
      enqueueSnackbar(res.payload.message, { variant: 'error' });
      if (typeof onFailed === 'function') {
        onFailed();
      }
    } else if (res?.payload?.status === 'success') {
      enqueueSnackbar(res.payload.message, { variant: 'success' });
      if (typeof onSuccess === 'function') {
        onSuccess();
      }
    }
  };

  return handleApiResponse;
};

export default useHandleApiResponse;
